export default {
  locationQuantity: ['1', '2-5', '6-20', '21-50', '50+'],
  employeesQuantity: ['<5', '6-20', '21-50', '51-150', '150+'],
  CDLDriversQuantity: ['<5', '6-20', '21-50', '51-150', '150+'],
  makeOfTractors: ['Volvo',
    'Freightliner',
    'Peterbilt',
    'Kenworth',
    'Mack',
    'International',
    'Other'
  ],
  healthInsuranceForEmployee: ['Full', 'Partial', 'None'],
  healthInsuranceForFamily: ['Full', 'Partial', 'None'],
  dentalInsuranceForEmployee: ['Full', 'Partial', 'None'],
  dentalInsuranceForFamily: ['Full', 'Partial', 'None'],
  visionInsuranceForEmployee: ['Full', 'Partial', 'None'],
  visionInsuranceForFamily: ['Full', 'Partial', 'None'],
  bonusesTypes: [
    'Safe working bonuses',
    'Driving based bonuses',
    'Fuel based bonuses',
    'Other'
  ],
  passengersTypes: [
    'Local positions',
    'Regional positions',
    'Over the road positions',
    'Team Driving positions',
    'Other'
  ],
  petsTypes: [
    'Local positions',
    'Regional positions',
    'Over the road positions',
    'Team Driving positions',
    'Other'
  ],
  other: ['Other']
}
